var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardLeftarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7308_8320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.582031C7.16344 0.582031 0 7.74548 0 16.582C0 25.4186 7.16344 32.582 16 32.582C24.8366 32.582 32 25.4186 32 16.582C32 7.74548 24.8366 0.582031 16 0.582031Z",
    fill: "#DCDCD9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.582L12 16.582L18 22.582",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 32.582H28C30.2091 32.582 32 30.7912 32 28.582L32 4.58203C32 2.37289 30.2091 0.582031 28 0.582031L4 0.582031C1.79086 0.582031 0 2.37289 0 4.58203V28.582C0 30.7912 1.79086 32.582 4 32.582Z",
    fill: "#DCDCD9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8089 17.3156L15.7785 21.2852L14.7179 22.3459L8.9375 16.5656L14.7179 10.7852L15.7785 11.8459L11.8089 15.8156H21.9982V17.3156H11.8089Z",
    fill: "#1D1D1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7308_8320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.582031)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLeftarrow);
export default __webpack_public_path__ + "static/media/card_leftarrow.0bb10578d782ec765f0a1e8e9f8fb52e.svg";
export { ForwardRef as ReactComponent };